
(function() {
  // Create modal HTML
  var modal = document.createElement('div');
  modal.id = 'qv-modal';
  modal.innerHTML = `
    <div id="qv-backdrop" style="position:fixed;inset:0;background:rgba(0,0,0,0.4);z-index:9998;opacity:0;transition:opacity 0.3s;pointer-events:none;"></div>
    <div id="qv-panel" style="position:fixed;right:0;top:0;bottom:0;width:480px;max-width:100vw;background:#fff;z-index:9999;transform:translateX(100%);transition:transform 0.35s ease;overflow-y:auto;box-shadow:-8px 0 32px rgba(0,0,0,0.12);">
      <div style="display:flex;justify-content:space-between;align-items:center;padding:20px 24px;border-bottom:1px solid #f0f0f0;">
        <span style="font-size:13px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;color:#888;">Quick View</span>
        <button id="qv-close" style="background:none;border:none;font-size:24px;cursor:pointer;color:#141414;line-height:1;">&times;</button>
      </div>
      <div id="qv-content" style="padding:24px;">
        <div style="text-align:center;padding:40px 0;color:#aaa;">Loading...</div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  function openModal() {
    var bd = document.getElementById('qv-backdrop');
    bd.style.opacity = '1';
    bd.style.pointerEvents = 'auto';
    document.getElementById('qv-panel').style.transform = 'translateX(0)';
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    var bd = document.getElementById('qv-backdrop');
    bd.style.opacity = '0';
    bd.style.pointerEvents = 'none';
    document.getElementById('qv-panel').style.transform = 'translateX(100%)';
    document.body.style.overflow = '';
  }

  document.getElementById('qv-close').addEventListener('click', closeModal);
  document.getElementById('qv-backdrop').addEventListener('click', closeModal);

  function loadProduct(handle) {
    var content = document.getElementById('qv-content');
    content.innerHTML = '<div style="text-align:center;padding:40px 0;color:#aaa;">Loading...</div>';
    openModal();

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var firstImg = p.images && p.images[0] ? p.images[0] : '';
        var minPrice = Math.min.apply(null, p.variants.map(function(v){ return parseFloat(v.price); }));
        
        // Build color swatches from variant options
        var colorOption = p.options.find(function(o){ return o.name.toLowerCase().includes('color'); });
        var sizeOption = p.options.find(function(o){ return o.name.toLowerCase().includes('size'); });
        
        var colorDots = '';
        if (colorOption) {
          colorDots = '<div style="margin-bottom:20px;"><div style="font-size:12px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;color:#999;margin-bottom:8px;">' + colorOption.name + '</div><div style="display:flex;gap:6px;flex-wrap:wrap;">';
          colorOption.values.slice(0,12).forEach(function(c) {
            colorDots += '<div title="' + c + '" style="width:24px;height:24px;border-radius:50%;background:#ddd;border:1.5px solid rgba(0,0,0,0.15);cursor:pointer;font-size:9px;display:flex;align-items:center;justify-content:center;overflow:hidden;"></div>';
          });
          if (colorOption.values.length > 12) colorDots += '<span style="font-size:11px;color:#aaa;align-self:center;">+' + (colorOption.values.length-12) + ' more</span>';
          colorDots += '</div></div>';
        }

        var sizeButtons = '';
        if (sizeOption) {
          sizeButtons = '<div style="margin-bottom:24px;"><div style="font-size:12px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;color:#999;margin-bottom:8px;">' + sizeOption.name + '</div><div style="display:flex;gap:8px;flex-wrap:wrap;">';
          sizeOption.values.forEach(function(s) {
            sizeButtons += '<button style="padding:7px 14px;border:1.5px solid #d0d0d0;border-radius:6px;font-size:13px;background:#fff;cursor:pointer;" onmouseover="this.style.borderColor=\'#141414\'" onmouseout="this.style.borderColor=\'#d0d0d0\'">' + s + '</button>';
          });
          sizeButtons += '</div></div>';
        }

        content.innerHTML = `
          <div style="aspect-ratio:1;background:#f5f5f5;border-radius:8px;overflow:hidden;margin-bottom:20px;">
            <img src="${firstImg}" alt="${p.title}" style="width:100%;height:100%;object-fit:cover;">
          </div>
          <h2 style="font-size:22px;font-weight:700;letter-spacing:-0.01em;margin-bottom:6px;">${p.title}</h2>
          <div style="font-size:16px;font-weight:600;color:#141414;margin-bottom:20px;">From $${(minPrice/100).toFixed(0)}</div>
          ${colorDots}
          ${sizeButtons}
          <div style="margin-bottom:16px;">
            <div style="font-size:12px;font-weight:600;letter-spacing:0.06em;text-transform:uppercase;color:#999;margin-bottom:8px;">Why BSB?</div>
            <ul style="list-style:none;padding:0;font-size:13px;color:#555;line-height:2;">
              <li>✦ Made to order &mdash; ships in 7&ndash;14 business days</li>
              <li>✦ Reusable, durable &amp; weatherproof</li>
              <li>✦ Indoor &amp; outdoor use</li>
              <li>✦ Ships worldwide</li>
            </ul>
          </div>
          <a href="/products/${p.handle}" style="display:block;background:#141414;color:#fff;text-align:center;padding:14px;border-radius:6px;font-size:14px;font-weight:700;letter-spacing:0.04em;text-decoration:none;margin-bottom:12px;">View Full Details &rarr;</a>
          <a href="/products/${p.handle}" style="display:block;border:1.5px solid #d0d0d0;color:#141414;text-align:center;padding:13px;border-radius:6px;font-size:13px;font-weight:600;text-decoration:none;">Add to Cart</a>
        `;
      })
      .catch(function() {
        content.innerHTML = '<div style="text-align:center;padding:40px;color:#aaa;">Could not load product. <a href="/products/' + handle + '">View on page</a></div>';
      });
  }

  // Attach to all .ed-card links on collection page
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.ed-card').forEach(function(card) {
      card.addEventListener('click', function(e) {
        e.preventDefault();
        var href = card.getAttribute('href');
        var handle = href.replace('/products/', '');
        loadProduct(handle);
      });
    });
  });
})();
